"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
const signatureDishes = [{
  id: "1",
  name: "Golden Hour Glow",
  origin: "Coastal Romance",
  shortDesc: "Soft light meeting the ocean's edge.",
  fullStory: "Captured during the final moments of sunset, this session focuses on the warm, ethereal glow that only the coast can provide. We utilize natural backlighting to create a dreamlike atmosphere that emphasizes the quiet intimacy between the couple as the tide recedes.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_golden_hour.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_golden_hour.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_golden_hour.png-wvc-sizes"
}, {
  id: "2",
  name: "Urban Elegance",
  origin: "Metropolitan Chic",
  shortDesc: "Modern lines and timeless affection.",
  fullStory: "Set against the architectural marvels of the city, this session blends contemporary style with classic romance. The interplay of shadows and sharp lines provides a sophisticated backdrop for couples who find beauty in the rhythm of urban life and refined aesthetics.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_urban_chic.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_urban_chic.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_urban_chic.png-wvc-sizes"
}, {
  id: "3",
  name: "Wildflower Meadow",
  origin: "Rustic Serenity",
  shortDesc: "Natural textures and organic love.",
  fullStory: "In the heart of a blooming meadow, we capture the effortless grace of love in the wild. This session is defined by soft-focus florals and a palette of muted greens and pastels, creating a nostalgic feeling reminiscent of fine-art film photography.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_meadow.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_meadow.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_meadow.png-wvc-sizes"
}, {
  id: "4",
  name: "Heritage Estate",
  origin: "Classic Grandeur",
  shortDesc: "Stately charm and enduring bonds.",
  fullStory: "The timeless architecture of a historic estate serves as the perfect stage for a love story that transcends generations. We focus on the intricate details of the stonework and the soft, diffused light of the gardens to create a collection of regal elegance.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_estate.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_estate.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_estate.png-wvc-sizes"
}, {
  id: "5",
  name: "Mist & Mountain",
  origin: "Highland Dream",
  shortDesc: "Atmospheric peaks and quiet whispers.",
  fullStory: "High above the clouds, the mountains offer a sense of scale and misticism. This session embraces the fog and the cool, desaturated tones of the highlands, resulting in imagery that feels both expansive and deeply personal.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_mountain.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_mountain.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/engagement_mountain.png-wvc-sizes"
}];
export default function JoyasDeLaBiodiversidad() {
  return <section data-section-id="252628" id="engagement-sessions" className="bg-background text-foreground py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 mb-12">
        <div className="max-w-3xl">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-light tracking-tight mb-6">
            The <span className="text-primary italic">Prelude</span>
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans max-w-2xl leading-relaxed">
            A curated gallery of intimate engagement sessions. 
            Capturing the movement, light, and the quiet anticipation of your journey together.
          </p>
        </div>
      </div>

      <div className="w-full pl-4 md:pl-6 lg:pl-8">
        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4">
            {signatureDishes.map((dish, i) => <CarouselItem key={dish.id} data-index={i} className="pl-4 basis-[85%] sm:basis-[60%] md:basis-[45%] lg:basis-[30%] 2xl:basis-[25%]">
                <Dialog>
                  <DialogTrigger asChild>
                    <div className="group relative h-[60vh] min-h-[500px] max-h-[700px] w-full overflow-hidden cursor-pointer rounded-md shadow-md">
                      <img src={dish.imageSrc} data-wvc-srcset={dish.imageSrcset} data-wvc-sizes={dish.imageSizes} alt={dish.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" />
                      
                      {}
                      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background/10 to-background/60 opacity-40 transition-opacity duration-500 group-hover:opacity-70" />

                      {}
                      <div className="absolute top-6 left-6 overflow-hidden">
                        <span className="block text-primary text-xs md:text-sm tracking-[0.2em] uppercase font-semibold translate-y-full opacity-0 transition-all duration-500 ease-out group-hover:translate-y-0 group-hover:opacity-100">
                          {dish.origin}
                        </span>
                      </div>

                      {}
                      <div className="absolute inset-0 flex items-center justify-center p-6">
                        <h3 className="font-default text-3xl md:text-4xl lg:text-5xl text-foreground text-center font-medium tracking-wide scale-95 opacity-0 transition-all duration-700 ease-out delay-100 group-hover:scale-100 group-hover:opacity-100">
                          {dish.name}
                        </h3>
                      </div>

                      {}
                      <div className="absolute bottom-8 left-6 right-6 overflow-hidden">
                        <p className="text-foreground/80 text-center font-serif italic text-lg md:text-xl translate-y-full opacity-0 transition-all duration-500 ease-out delay-200 group-hover:translate-y-0 group-hover:opacity-100">
                          {dish.shortDesc}
                        </p>
                      </div>
                    </div>
                  </DialogTrigger>
                  <DialogContent className="bg-card text-card-foreground border-border sm:max-w-2xl p-0 overflow-hidden rounded-lg shadow-xl">
                    <div className="relative h-64 sm:h-80 w-full">
                      <img src={dish.imageSrc} data-wvc-srcset={dish.imageSrcset} data-wvc-sizes={dish.imageSizes} alt={dish.name} className="absolute inset-0 w-full h-full object-cover" />
                      <div className="absolute inset-0 bg-gradient-to-t from-card to-transparent" />
                    </div>
                    <div className="p-8 sm:p-10 pt-0 relative z-10 -mt-12">
                      <DialogHeader className="mb-6">
                        <span className="text-primary text-sm tracking-[0.2em] uppercase font-semibold mb-2 block">
                          {dish.origin}
                        </span>
                        <DialogTitle className="font-default text-3xl sm:text-4xl font-medium text-foreground">
                          {dish.name}
                        </DialogTitle>
                      </DialogHeader>
                      <DialogDescription className="text-muted-foreground text-base sm:text-lg leading-relaxed font-sans">
                        {dish.fullStory}
                      </DialogDescription>
                    </div>
                  </DialogContent>
                </Dialog>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="flex items-center justify-end gap-4 pr-4 md:pr-6 lg:pr-8 mt-12">
            <CarouselPrevious className="relative inset-auto translate-y-0 size-12 rounded-md border-border hover:bg-accent hover:text-accent-foreground hover:border-accent transition-colors shadow-sm" />
            <CarouselNext className="relative inset-auto translate-y-0 size-12 rounded-md border-border hover:bg-accent hover:text-accent-foreground hover:border-accent transition-colors shadow-sm" />
          </div>
        </Carousel>
      </div>
    </section>;
}